var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Tableau = function (_a) {
    var caption = _a.caption, children = _a.children, _b = _a.avecBordure, avecBordure = _b === void 0 ? false : _b, _c = _a.sansScroll, sansScroll = _c === void 0 ? false : _c, _d = _a.tailleFixe, tailleFixe = _d === void 0 ? false : _d, _e = _a.noCaption, noCaption = _e === void 0 ? false : _e, _f = _a.captionEnBas, captionEnBas = _f === void 0 ? false : _f, couleur = _a.couleur, className = _a.className, otherProps = __rest(_a, ["caption", "children", "avecBordure", "sansScroll", "tailleFixe", "noCaption", "captionEnBas", "couleur", "className"]);
    var classTableau = className + ' fr-table';
    if (avecBordure) {
        classTableau += ' fr-table--bordered';
    }
    if (sansScroll) {
        classTableau += ' fr-table--no-scroll';
    }
    if (tailleFixe) {
        classTableau += ' fr-table--layout-fixed';
    }
    if (noCaption) {
        classTableau += ' fr-table--no-caption';
    }
    if (captionEnBas) {
        classTableau += ' fr-table--caption-bottom';
    }
    if (couleur) {
        classTableau += ' fr-table--' + couleur;
    }
    return (React.createElement("div", __assign({}, otherProps, { className: classTableau }),
        React.createElement("table", null,
            React.createElement("caption", null, caption),
            children)));
};
export default Tableau;
